import $ from 'jquery'

// set value from category to hidden field
$(document).on('click', '.round-check_box', function () {
  const $el = $(this)
  $el.toggleClass('selected')
  $el.find('input').prop('checked', !$el.find('input').prop('checked'))
})
